import { render, staticRenderFns } from "./fee-add-or-update.vue?vue&type=template&id=be12d79c&lang=pug"
import script from "./fee-add-or-update.vue?vue&type=script&lang=js"
export * from "./fee-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./fee-add-or-update.vue?vue&type=style&index=0&id=be12d79c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports